// extracted by css-extract-rspack-plugin
export default {"size_s":"qJhaD","sizeS":"qJhaD","left_icon":"M6RHV","leftIcon":"M6RHV","size_m":"tzidR","sizeM":"tzidR","size_l":"xoJ_G","sizeL":"xoJ_G","size_xl":"BTIy1","sizeXl":"BTIy1"};